export enum SoldOutCaseKindEnum {
    ITEM = "ITEM",
    PREPARATION = "PREPARATION",
    EQUIPMENT = "EQUIPMENT",
}
